import React from 'react';
import classNames from 'classnames';

import IconBgWaves from '@app/src/assets/bg-waves.svg';
import IconBgMain from '@app/src/assets/login-pic.svg';

import './AuthWindow.scss';

interface IProps {
  className?: string;
}

const AuthWindow = ({
  className,
  children
}: React.PropsWithChildren<IProps>) => {
  return (
    <section className={classNames('auth-window', className)}>
      <IconBgWaves className="auth-window__icon-bg-waves" />
      <IconBgMain className="auth-window__icon-bg-main" />
      {children}
    </section>
  );
};

export default AuthWindow;
